
import { every } from 'lodash-es'
import { Component, Mixins, Watch } from 'vue-property-decorator'
import ActivationConditions from '~/components/common/activation-conditions'
import AutoApplicationModal from '~/components/common/modals/auto-application-modal/AutoApplicationModal.vue'
import AutoApplicationModalRefusal from '~/components/common/modals/auto-application-modal/AutoApplicationModalRefusal.vue'
import AutoApplicationModalSuccess from '~/components/common/modals/auto-application-modal/AutoApplicationModalSuccess.vue'
import { AUTOMATIC_APPLICATION_MODAL, DEBUG_MODE } from '~/plugins/feature-flags/flags'

@Component({
  components: {
    AutoApplicationModal
  }
})
export default class AutoApplicationModalProvider extends Mixins(ActivationConditions) {
  isWatcherDone = false

  getVisibilityConditions() {
    const isFeatureEnabled = this.$featureFlags?.isEnabled?.(AUTOMATIC_APPLICATION_MODAL)
    const { isFreemium } = this.$accessor.account
    const isSettingAlreadyEnabled = this.$accessor.account.accountConfigAutoApplication.enabled
    const isActivationPopupSeen = this.$cookies.get('activation-popup-seen')
    const isActivationPaidPopupDue = !isActivationPopupSeen && every(this.activationGetVisibilityConditions())
    const isAutoApplicationPopupSeen = this.$cookies.get('auto-application-popup-seen')

    return {
      notActivationPaidPopupDue: !isActivationPaidPopupDue,
      isFeatureEnabled,
      notFreemium: !isFreemium,
      notSeenBefore: !isAutoApplicationPopupSeen,
      notEnabled: !isSettingAlreadyEnabled
    }
  }

  maybeShow() {
    const close = () => { this.$modal.hide('AutoApplicationModal') }
    const { events, track } = this.$mixpanel

    if (every(this.getVisibilityConditions())) {
      this.$modal.show(AutoApplicationModal, {
        yesHandler: async() => {
          track(events.AUTOMATIC_APPLICATION_MODAL_YES_BUTTON_CLICK)
          await this.$accessor.account.storeAutoApplicationSetting(true)
          close()
          this.$modal.show(AutoApplicationModalSuccess, null, {
            name: 'AutoApplicationModalSuccess',
            width: 632,
            clickToClose: true
          })
        },
        noHandler: () => {
          track(events.AUTOMATIC_APPLICATION_MODAL_NO_BUTTON_CLICK)
          close()
          this.$modal.show(AutoApplicationModalRefusal, null, {
            name: 'AutoApplicationModalRefusal',
            width: 632,
            clickToClose: true
          })
        }
      }, {
        name: 'AutoApplicationModal',
        width: 632
      }, {
        opened: () => {
          track(events.AUTOMATIC_APPLICATION_MODAL_OPEN)
          this.$cookies.set('auto-application-popup-seen', true)
        }
      })
    } else if (this.$featureFlags?.isEnabled?.(DEBUG_MODE)) {
      // eslint-disable-next-line no-console
      console.warn('AutoApplication modal was not displayed because some of the conditions are not met.', this.getVisibilityConditions())
    }
  }

  @Watch('$store.state.initialized', { immediate: true })
  maybeShowOnInit(isInitialized: boolean) {
    if (!isInitialized || this.isWatcherDone) { return }
    this.maybeShow()
    this.isWatcherDone = true
  }

  debugShow() {
    this.$cookies.remove('auto-application-popup-seen')
    this.maybeShow()
  }

  created() {
    this.$root.$on('debug:show-auto-application-modal', this.debugShow)
  }

  beforeDestroy() {
    this.$root.$off('debug:show-auto-application-modal', this.debugShow)
  }
}
